import type { FC } from 'react';
import type { ModalProps } from 'antd/lib/modal';
import { Modal as AntdModal } from 'antd';

import Close from './icons';
import { Button } from '../MiButton';

const Modal: FC<ModalProps> = ({
    children,
    className = '',
    onOk,
    onCancel,
    onClose,
    okText = 'Применить',
    cancelText = 'Отмена',
    okButtonProps,
    title,
    ...props
}) => {
    return (
        <AntdModal
            className={`customAntdModal ${className}`}
            footer={[
                <Button onClick={onCancel} key="cancel">
                    {cancelText}
                </Button>,
                <Button type="primary" key="submit" onClick={onOk} {...okButtonProps}>
                    {okText}
                </Button>,
            ]}
            closable={false}
            title={
                <div className="flex h-8 items-center justify-between px-4 pr-1">
                    <span className="text-xs font-semibold">{title}</span>
                    <Button type="text" className="!px-2" onClick={onClose ?? onCancel}>
                        <Close className="stroke-gray-700 hover:stroke-black dark:stroke-font-secondary dark:opacity-40  dark:hover:stroke-font-tertiary" />
                    </Button>
                </div>
            }
            centered
            {...props}
        >
            {children}
        </AntdModal>
    );
};

export default Modal;
